const rawBaseUrl = String(process.env.REACT_APP_API_BASE_URL || "").trim();

const normalizeMainUrl = (value) => {
  const cleaned = String(value || "").trim().replace(/\/+$/, "");
  if (!cleaned) {
    return "http://localhost:8000";
  }
  if (cleaned.startsWith("http://") || cleaned.startsWith("https://")) {
    return cleaned;
  }
  return `http://${cleaned}`;
};

// Prefer the origin the app is currently served from so a single build works on
// every domain it is deployed under (main domain, backup domain, staging, ...).
// Requests stay same-origin, which keeps the session cookie working without CORS.
const resolveRuntimeOrigin = () => {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  const origin = String(window.location.origin || "").trim().replace(/\/+$/, "");
  return origin && origin !== "null" ? origin : "";
};

const mainUrl = normalizeMainUrl(
  resolveRuntimeOrigin() || process.env.REACT_APP_MAIN_URL || ""
);

const BASE_URL = (rawBaseUrl || `${mainUrl}/api/v1`).replace(/\/+$/, "");

export default BASE_URL;
